import { List, ListItem, Text } from '@redbubble/design-system';
import { usePageProps } from '@redbubble/next-provider';
import { useCurrentInventoryStore } from '../../hooks/useCurrentInventoryItem';
import { ProductPageProps } from '../../types';

export const ProductFeatures = () => {
  const { currentInventoryItem } = useCurrentInventoryStore((state) => state);
  const { productDescriptions } = usePageProps<ProductPageProps>();
  const longDescription = productDescriptions[
    currentInventoryItem.productTypeId
  ] ?? [''];
  return (
    <List bulleted>
      {longDescription.map((info) => (
        <ListItem key={info}>
          <Text type="body">{info}</Text>
        </ListItem>
      ))}
    </List>
  );
};
